import React, { useState, useContext } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import LargeButton from "../../components/buttons/LargeButton";
import propTypes from "prop-types";
import './EnterPaymentInfo.css';
import { AuthContext } from "../../context/AuthContext";
import config from "../../config";

function EnterPaymentInfo({
  clientSecret,
  setPaymentStep,
  setSessionId,
  setSuccess,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useContext(AuthContext);
  // Handle payment confirmation and subscription creation
  const handleConfirmPayment = async (event) => {
    event.preventDefault();

    if (!stripe || !elements || !clientSecret) {
      setErrorMessage("Payment setup is incomplete. Please try again.");
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
        // trigger form validation & wallet collection
        const { error: submitError } = await elements.submit();
        if(submitError){
            console.log(error.message);
        }

      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: "https://localhost:3000/subscription/reid",
        },
        redirect: "if_required",
      });

      if (error) {
        console.log(error.message);
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        const response = await fetch(`${config.apiUrl}/subscriptions/create-subscription`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                userId: user._id,
                paymentIntentId: paymentIntent.id,
                productId: "prod_Rwbh8pk544VF1B",
            }),
        });

        if(!response.ok){
            const error = await response.json();
            throw new Error(error.error || "failed to create subscription");
        }

        const { subscriptionId } = await response.json();
        console.log("Subscription created!", subscriptionId);

        setSuccess(true);
        setSessionId(paymentIntent.id);
        setPaymentStep(3);
      } else {
        setErrorMessage(
          "Payment processing completed, but status is unclear. Please contact support."
        );
      }
    } catch (error) {
      setErrorMessage(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="payment-info-container">
      {!stripe || !elements ? (
        <p>Loading payment options...</p>
      ) : (
        <form className="payment-container-form" onSubmit={handleConfirmPayment}>
          <div className="payment-element-wrapper">
            <PaymentElement
              options={{
                layout: "tabs",
                fields: {
                  billingDetails: {
                    email: "auto",
                  },
                },
              }}
            />
          </div>
          <LargeButton
            id="confirm-payment-button"
            type="submit"
            text={isLoading ? "Processing..." : "Confirm Payment"}
            disabled={isLoading || !stripe || !elements}
          />
          {errorMessage && (
            <p className="sub-error-message">{errorMessage}</p>
          )}
        </form>
      )}
    </div>
  );
}

export default EnterPaymentInfo;

EnterPaymentInfo.propTypes = {
  clientSecret: propTypes.string,
  setPaymentStep: propTypes.func,
  setSessionId: propTypes.func,
  setSuccess: propTypes.func,
  user: propTypes.shape({
    email: propTypes.string,
    _id: propTypes.object,
  }),
};
